export const formatByteSize = (byteCount: number) => {
    if (byteCount === 0) return "0 Bytes";
    // The firmware uses -1 as an "unreadable path" sentinel (GetDirectorySizeBytes and
    // GetDiskSpaceBytes both return it), and Math.log of a negative is NaN, which rendered
    // as the literal "NaN undefined" in storage tooltips.
    if (!Number.isFinite(byteCount) || byteCount < 0) return "—";
    const k = 1000;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    // Clamp, or anything past the last unit indexes off the end and renders "… undefined".
    const i = Math.min(Math.floor(Math.log(byteCount) / Math.log(k)), sizes.length - 1);
    return `${parseFloat((byteCount / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

/** Mirrors MDNSService.SanitizeDnsLabel on the backend. */
export function sanitizeDnsLabel(name?: string | null): string {
    if (!name?.trim()) {
        return "omniradar";
    }
    const s = [...name.toLowerCase()].map(c => {
        if (/[a-z0-9]/.test(c)) return c;
        if (c === " " || c === "_") return "-";
        if (c === "-") return "-";
        return "";
    }).join("").replace(/-{2,}/g, "-").replace(/^-+|-+$/g, "");
    const label = s.length > 63 ? s.slice(0, 63).replace(/-+$/, "") : s;
    return label || "omniradar";
}

export const emptyGuid = "00000000-0000-0000-0000-000000000000";